import React from 'react';
import Header from '../../components/header/header';
import About from '../../components/about/about';
import Experience from '../../components/experience/experience';
import Skills from '../../components/skills/skills';
import Projects from '../../components/projects/projects';
import Contact from '../../components/contact/contact';
import Education from '../../components/education/education';
import Certifications from '../../components/certifications/certifications';
import BackgroundSpace from '../../components/background-space/background-space';


const Home = () => {

    return (
        <div>
            <Header />
            <About />
            <Experience/>
            <Skills/>
            <Education/>
            <Projects/>
            <Certifications/>
            <Contact/>
            <BackgroundSpace />
        </div>
    );
}

export default Home;